import { defineTranslateKeys } from 'lib/tolgee'
import { MAX_FILE_SIZE } from 'services/documents/consts'

import { bytesToMb } from './documents.utils'

export const translations = defineTranslateKeys({
  errorDeletingDocument: {
    key: 'documents-error-deleting-document',
    defaultValue: 'Erro ao deletar o documento. Tente novamente.',
  },
  documentDeletedSuccessfully: {
    key: 'documents-delete-success-message',
    defaultValue: 'Documento deletado com sucesso.',
  },
  errorStorageQuotaExceeded: {
    key: 'documents-error-storage-quota-exceeded',
    defaultValue: 'Espaço de armazenamento insuficiente. Exclua alguns arquivos para continuar.',
  },
  errorUploadFailed: (fileName: string) => ({
    key: 'documents-error-upload-failed',
    parameters: { fileName },
    defaultValue: 'Falha ao enviar o arquivo "{fileName}". Tente novamente.',
  }),
  errorFileSizeExceededSingle: (fileName: string) => ({
    key: 'documents-error-file-size-exceeded-single-provisional',
    // Due to the limitations of the toast system regarding HTML tags, we are using 'span' tag here to wrap the entire message
    parameters: { fileName, limit: `${bytesToMb(MAX_FILE_SIZE)} MB`, strong: <strong></strong>, span: <span></span> },
    defaultValue:
      '<span>Não foi possível adicionar o arquivo <strong>{fileName}</strong> pois ele excede o limite de {limit}.</span>',
  }),
  errorFileSizeExceededMultiple: (count: number) => ({
    key: 'documents-error-file-size-exceeded-multiple',
    parameters: { count, limit: `${bytesToMb(MAX_FILE_SIZE)} MB` },
    defaultValue: 'Não foi possível adicionar {count} arquivos porque cada um ultrapassa o limite de {limit}.',
  }),
  uploadSuccessMultiple: (count: number) => ({
    key: 'documents-upload-success-multiple',
    parameters: { count },
    defaultValue: '{count, plural, one {Documento enviado} other {# documentos enviados}} com sucesso.',
  }),
})
